export default {
      id: "money-hand-usage",
      viewBox: "0 0 21 18",
      url: __webpack_public_path__ + "sprite.svg#money-hand",
      toString: function () {
        return this.url;
      }
    }